import React, { Component } from 'react';
import '../css/App.css';
import axios from 'axios';
import API from '../config_api';
import { connect } from 'react-redux';
import { fetchLoginData } from '../redux/loginData/LoginAction';
import Loader from '../component/Loader';
import FormInput from '../component/FormInput';
import Button from '../component/Button';
import Cookies from 'js-cookie';
import { handleApiError } from '../utils/errorHandler';

class UserLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            recaptchaLoaded: false,
            recaptchaVerified: false,
            recaptchaToken: '',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onRecaptchaSuccess = this.onRecaptchaSuccess.bind(this);
    }

    componentDidMount() {
        // Load Google Invisible reCAPTCHA script dynamically
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';
        script.async = true;
        script.defer = true;
        window.onRecaptchaLoad = () => {
            this.setState({ recaptchaLoaded: true }, () => {
                window.grecaptcha.render('invisible-recaptcha', {
                    sitekey: '6LeF0JQqAAAAAEkfuALD2PggGKFpHjetJ1rNvIMC',
                    size: 'invisible',
                    callback: this.onRecaptchaSuccess,
                });
            });
        };
        document.body.appendChild(script);
    }

    componentWillMount() {
        if (localStorage.getItem('token')) {
            this.props.history.push('/dashboard');
        }
        if (!localStorage.getItem('company_id')) {
            this.props.history.push('/');
        }
        localStorage.setItem('company_id', 'kauvery');
    }

    onRecaptchaSuccess(token) {
        this.setState({ recaptchaToken: token, recaptchaVerified: true }, this.performLogin);
    }

    handleSubmit(event) {
        event.preventDefault();

        const email = event.target[0].value;
        const password = event.target[1].value;

        if (!email) {
            alert('Please enter Email/AcuiZen Id');
            return;
        } else if (!password) {
            alert('Please enter password');
            return;
        }

        // Trigger Invisible reCAPTCHA
        if (this.state.recaptchaLoaded) {
            window.grecaptcha.execute();
        } else {
            alert('reCAPTCHA is not loaded yet. Please refresh the page.');
        }
    }

    performLogin() {
        const email = document.querySelector('[name="username"]').value;
        const password = document.querySelector('[name="password"]').value;

        if (!this.state.recaptchaToken) {
            alert('CAPTCHA verification failed. Please try again.');
            return;
        }

        let formData = new FormData();
        formData.append('user_email', email);
        formData.append('user_password', password);
        formData.append('company_id', 'kauvery');
        formData.append('device_type', '1');
        formData.append('device_token', localStorage.getItem('notification-token'));
        formData.append('recaptcha_token', this.state.recaptchaToken);

        axios({
            method: 'post',
            url: API.CheckParallel,
            data: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
        })
            .then(response => {
                if (response.status === 'success') {
                    this.props.loginData(email, password, this.props);
                } else if (response.status === 'invalid') {
                    alert('Invalid credentials');
                } else {
                    this.props.loginData(email, password, this.props);
                }
            })
            .catch(error => {
                handleApiError(error);
            });

        // Reset reCAPTCHA after submission
        window.grecaptcha.reset();
    }

    render() {
        return (
            <div className="main-content h-h align-item-center">
                <div className="container ">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-7 col-xs-11">
                            <div className="card border-0 mb-0 pad_z">
                                <div className="card-body px-lg-5 py-lg-5">
                                    <div className="text-center">
                                        <img
                                            src={require('../images/LOGO.png')}
                                            alt="az_logo"
                                            className="img-responsive mb-40"
                                            style={{ height: 100 }}
                                        />
                                    </div>
                                    <div className="text-center text-muted mb-4">
                                        <large>Let's get Started</large>
                                    </div>
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="form-group mb-3">
                                            <div className="input-group input-group-merge ">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <i className="ni ni-circle-08"></i>
                                                    </span>
                                                </div>
                                                <FormInput name="username" placeholder="Enter Your Employee Number" type="text" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <i className="ni ni-lock-circle-open"></i>
                                                    </span>
                                                </div>
                                                <FormInput name="password" placeholder="Enter Your Password" type="password" />
                                            </div>
                                        </div>
                                        <div id="invisible-recaptcha"></div>
                                        <div className="text-center">
                                            <Button color="btn-primary az-color" type="submit" variant="my-4" size="large">
                                                Sign In
                                            </Button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.loader && <Loader />}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state.login.data,
        loader: state.login.loading,
        error: state.login.error,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loginData: (email, password, props) => dispatch(fetchLoginData(email, password, props)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserLogin);
